import { render, staticRenderFns } from "./PurchaseInfo.vue?vue&type=template&id=8ca5bcfc&scoped=true"
import script from "./PurchaseInfo.vue?vue&type=script&lang=js"
export * from "./PurchaseInfo.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInfo.vue?vue&type=style&index=0&id=8ca5bcfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca5bcfc",
  null
  
)

export default component.exports